import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import Card from '../ui/Card';
import Button from '../ui/Button';

const PaymentFailed = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  const reason = searchParams.get('reason');

  const getFailureMessage = () => {
    switch (reason) {
      case 'expired':
        return 'The payment link has expired. Payment links are valid for 24 hours only.';
      case 'cancelled':
        return 'The payment was cancelled.';
      default:
        return 'Your payment could not be processed.';
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 48px)',
      padding: '20px'
    }}>
      <Card style={{
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center',
        padding: '40px 30px'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          backgroundColor: 'var(--color-danger-bg-strong)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px'
        }}>
          <XCircle size={48} color="#ef4444" />
        </div>

        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: 'var(--color-text-primary)',
          margin: '0 0 12px 0'
        }}>
          Payment Failed
        </h1>

        <p style={{
          fontSize: '16px',
          color: 'var(--color-text-muted)',
          margin: '0 0 32px 0',
          lineHeight: '1.5'
        }}>
          {getFailureMessage()}
        </p>

        {orderId && (
          <div style={{
            padding: '12px 16px',
            backgroundColor: 'var(--color-bg-inset)',
            borderRadius: '8px',
            marginBottom: '32px'
          }}>
            <p style={{
              fontSize: '12px',
              color: 'var(--color-text-muted)',
              margin: '0 0 4px 0'
            }}>
              Order ID
            </p>
            <p style={{
              fontSize: '14px',
              fontWeight: '600',
              color: 'var(--color-text-primary)',
              margin: 0,
              fontFamily: 'monospace'
            }}>
              {orderId}
            </p>
          </div>
        )}

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}>
          <Button
            onClick={() => navigate('/dashboard')}
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              backgroundColor: 'var(--color-accent)',
              color: 'white'
            }}
          >
            <RefreshCw size={18} />
            Try Again
          </Button>

          <Button
            onClick={() => navigate('/dashboard')}
            variant="secondary"
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              backgroundColor: 'var(--color-bg-inset)',
              color: 'var(--color-text-secondary)'
            }}
          >
            <ArrowLeft size={18} />
            Back to Dashboard
          </Button>
        </div>

        <div style={{
          marginTop: '24px',
          padding: '16px',
          backgroundColor: 'var(--color-warning-bg)',
          borderRadius: '8px',
          border: '1px solid var(--color-warning-bg-strong)'
        }}>
          <p style={{
            fontSize: '12px',
            color: 'var(--color-warning-fg)',
            margin: 0,
            lineHeight: '1.5'
          }}>
            <strong>Need help?</strong> If you believe this is an error, please contact support with your order ID.
          </p>
        </div>
      </Card>
    </div>
  );
};

export default PaymentFailed;
